import React from "react";

// Inline placeholder for route chunks and auth checks. It sits inside the
// page rather than covering it, so the header and footer never disappear.
const PageLoader: React.FC = () => (
  <div className="flex min-h-[50vh] items-center justify-center" role="status">
    <div className="spinner" />
    <span className="sr-only">Loading…</span>
  </div>
);

export default PageLoader;
